const getters = {
  token: state => state.user.token,
  role: state => state.user.role,
  group: state => state.user.group
};

export default getters;
